import styled from 'styled-components';

import { BasicParagraph } from '@genially/design-system';

export const Wrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  width: size.units(40),
}));

export const MoreParticipantsText = styled(BasicParagraph)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));
